<template>

    <div v-if="this.isPanelVisible && $store.getters['comparisonDataUpdated']" style="position:absolute; z-index:100; bottom:35px; right: 10px;">
      <div style="background:#ffffff; display:flex; flex-wrap:wrap; width:600px; border-radius:5px">
        <div style="flex: 1 0 200px; display:flex; justify-content:space-between; padding:5px 5px 5px 10px">
          <div>
            <div style="font-weight: 700;">
              <span style="color:#585858;" v-if="this.displayedLayers[0]">{{this.displayedLayers[0].title}}</span>
              <span v-else style="color:#cbcbcb">{{ $t('noLayer') }}</span>
            </div>
            <div style="color:#7a7a7a;">
              <span v-if="this.displayedLayers[0]" style="white-space: pre-line;">{{this.displayedLayers[0].timeString}}</span>
              <span v-else> - </span>
            </div>
          </div>
          <div style="flex: 0 0; display:flex; flex-direction:column; justify-content:space-between">
            
            <b-button style="color:#585858" size="is-small" type="is-ghost" icon-right="swap-horizontal" @click="swapLayers()" :disabled="this.$store.getters['isComparisonModeActive']"/>
            <b-button style="color:#585858" size="is-small" type="is-ghost" icon-right="delete" @click="removeLayer(0)"/>
            
          </div>
        </div>
        <div style="flex: 0 0 1px; background:#dbdbdb">
        </div>
        <div style="flex: 1 0 200px; display:flex; justify-content:space-between; padding:5px 5px 5px 10px">
          <div>
            <div style="font-weight: 700;">
              <span style="color:#585858;" v-if="this.displayedLayers[1]">{{this.displayedLayers[1].title}}</span>
              <span v-else style="color:#cbcbcb">{{ $t('noLayer') }}</span>
            </div>
            <div style="color:#7a7a7a;">
              <span v-if="this.displayedLayers[1]" style="white-space: pre-line;">{{this.displayedLayers[1].timeString}}</span>
              <span v-else> - </span>
            </div>
          </div>
          <div style="flex: 0 0; display:flex; flex-direction:column; justify-content:space-between">
            
            <b-button style="color:#585858" size="is-small" type="is-ghost" icon-right="swap-horizontal" @click="swapLayers()" :disabled="this.$store.getters['isComparisonModeActive']"/>
            <b-button style="color:#585858" size="is-small" type="is-ghost" icon-right="delete" @click="removeLayer(1)"/>
            
          </div>
        </div>
      </div>
      <div>
        <div style="display:flex; justify-content:space-between; margin-top: 5px">
          <b-button icon-left="select-compare" @click="compareLayers()" :disabled="displayedLayers[0] === undefined || displayedLayers[1] === undefined">{{ $t('compareLayers') }}</b-button>
          <b-button icon-left="exit-to-app" @click="exitComparison()">{{ $t('exitComparison') }}</b-button>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      isPanelVisible: false,
      displayedLayers: []
    }
  },
  mounted () {
    this.subscribe()
  },
  methods: {
    subscribe () {
      this.$store.watch(
        () => this.$store.getters['comparisonDataUpdated'],
        updated => {
          const layers = this.$store.getters['layersToCompare']
          if (layers.every(layer => layer === undefined)) {
            this.displayedLayers = []
            this.isPanelVisible = false
          } else {
            this.displayedLayers = layers
            this.isPanelVisible = true
          }
        }
      )
    },
    removeLayer (id) {
      this.$store.dispatch('removeLayerToCompare', id)
    },
    swapLayers () {
      this.$store.dispatch('swapLayersToCompare')
    },
    compareLayers () {
      this.$store.dispatch('enterComparisonMode', this.$map)
    },
    exitComparison () {
      this.$store.dispatch('leaveComparisonMode')
    }
  }
}

</script>

<style lang="stylus" scoped>

</style>
